import React, { useContext, useEffect, useState } from 'react';

import { Table, TableBody, TableCell, TableHead, TableRow } from '@material-ui/core';

import { GlobalContext } from '../../../../store';

import {
  useAssignResultsDispatch,
  useAssignResultsState
} from '../../../admin/EventWizard/Common/AssignResults/Context/AssignResults.context';
import { useEventLeaderboardsState } from '../Context/EventLeaderboards.context';
import { ExpandableCTPTableRow } from './Components/ExpandableCTPTableRow';

export const CTPTable = () => {
  const {
    actions: {
      holeResults: { get: getHoleResults }
    },
    holeResults
  } = useContext(GlobalContext);

  const { selectedFlightId, selectedRound } = useEventLeaderboardsState();

  const { results, selectedRoundFormat, selectedScoreType, ctpResults } = useAssignResultsState();

  const [roundId, setRoundId] = useState<number>();

  useEffect(() => {
    if (selectedRound) {
      setRoundId(selectedRound.id);
    }
  }, [selectedRound]);

  const {
    actions: { setCTPResults },
    dispatch: dispatchAssignResults
  } = useAssignResultsDispatch();

  const [CTPHoles, setCTPHoles] = useState<number[]>([]);

  useEffect(() => {
    const ctpHoles =
      selectedRoundFormat && selectedRoundFormat.metadata && roundId
        ? selectedRoundFormat.metadata[Number(roundId)]
        : [];

    setCTPHoles(ctpHoles);
  }, [selectedRoundFormat, roundId]);

  useEffect(() => {
    if (roundId) {
      getHoleResults(roundId);
    } else if (selectedRound) {
      getHoleResults(selectedRound.id);
    }
  }, [roundId, selectedRound]);

  useEffect(() => {
    dispatchAssignResults({ type: 'sortResults' });
  }, [results]);

  useEffect(() => {
    if (roundId && selectedRoundFormat && selectedScoreType) {
      setCTPResults(holeResults, Number(roundId), selectedRoundFormat.considerFlights);
    }
  }, [holeResults, selectedScoreType, selectedRoundFormat, selectedFlightId]);

  const [collapsedRow, setCollapsedRow] = useState<number>();

  const onClick = (index: number) => () =>
    setCollapsedRow(collapsedRow === index ? undefined : index);

  return (
    <div className="event-leaderboards-table horseRaceTable">
      <Table className="leaderboard-score-table">
        <colgroup>
          {[0, 1, 2, 3].map(index => (
            <col key={index} />
          ))}
        </colgroup>

        <TableHead className="leaderboard__thead">
          <TableRow className="leaderboard-header">
            <TableCell className="leaderboard-header__cell override index">Hole</TableCell>

            <TableCell className="leaderboard-header__cell override playerName">Player</TableCell>

            <TableCell className="leaderboard-header__cell override result">Distance</TableCell>

            <TableCell className="leaderboard-header__cell override result" />
          </TableRow>
        </TableHead>

        <TableBody className="leaderboard__tbody">
          {ctpResults && Object.keys(ctpResults).length > 0 ? (
            Object.keys(ctpResults).map((hole: string, index: number) =>
              CTPHoles && CTPHoles.includes(Number(hole) + 1) ? (
                <ExpandableCTPTableRow
                  key={`ExpandableCTPTableRow-${hole}`}
                  hole={hole}
                  index={index}
                  onClick={onClick}
                  collapsedRow={collapsedRow}
                />
              ) : (
                <div key={`ExpandableCTPTableRow-${hole}`} />
              )
            )
          ) : (
            <TableRow>
              <TableCell colSpan={4} className="no-results">
                No results to show
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </div>
  );
};
